// TinyPDFs placements mapped to the dashboard placeholders configured for
// tinypdfs.com. Placeholder ids are intentionally reused across routes, but
// never more than once on the same page.
export const EZOIC_PLACEMENT_IDS = Object.freeze({
  'home.hero_below': 101,
  'home.library_top': 102,
  'home.library_below': 109,
  'home.premium_above': 110,
  'home.products_above': 111,
  'home.footer_above': 103,

  'products.list_top': 101,
  'products.list_bottom': 103,

  'pdfs.list_top': 101,
  'pdfs.library_top': 102,
  'pdfs.library_below': 111,
  'pdfs.list_bottom': 103,

  'product.below_description': 109,
  'product.recommendations': 111,
  'product.footer_above': 103,

  'pdf.detail_top': 102,
  'pdf.detail_before_download': 109,
  'pdf.detail_sidebar': 104,
  'pdf.detail_recommendations': 103,

  'dashboard.top_banner': 101,
  'dashboard.premium_promo': 102,
  'dashboard.sidebar': 104,
  'dashboard.purchases_below': 111,
  'dashboard.recommendations': 103,

  'checkout.success_loading': 101,
  'checkout.error_below': 103,
  'checkout.cancel_below': 101,
  'checkout.cancel_recommendations': 103,

  'purchase.confirm_inline': 102,
  'purchase.confirm_recommendations': 111,
  'purchase.confirm_promo': 103,

  'subscription.loading_below': 101,
  'subscription.error_below': 103,
  'subscription.confirm_promo': 102,
  'subscription.confirm_recommendations': 103,
  'subscription.cancel_below': 101,
  'subscription.cancel_recommendations': 103,

  'download.ready_inline': 102,
  'download.ready_recommendations': 103,
});

export function getEzoicPlacementId(placementKey) {
  return EZOIC_PLACEMENT_IDS[String(placementKey || '').trim()] || null;
}
